import PubSub from "underpub-js";

var Recipe = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Recipe',
	};

	$.extend(true, this.options, options);

};

Recipe.prototype.init = function() {

	var self = this;

};

export default Recipe;
